<template>
    <div class="pt403" id="pt403" v-cloak>
        <!--パンくずリスト-->
       <breadcrumb :navListCustom="[{title:'マイページ', routerName: SiteConstants.PG010MAIN, param: {pageNo: '81'}}
            ,{title:$t('pt403.labels.changePassword'), routerName: '', param: {}}]">
        </breadcrumb>
        <div class="section">
            <!-- タイトル「パスワード再設定」 -->
            <div class="itemTitle">
                <h2>{{$t('pt403.labels.changePassword')}}</h2>
            </div>
            <div class="sectionInner">
                <div v-if="mapMessValid.length > 0 || listMessValid.length > 0" class="errorMessage">
                    <message :listMess="listMessValid" :mapMsg="mapMessValid" :idScreen="'pt403'"/>
                </div>
                <template v-if="processType == '0'">
                    <div class="msg" v-html="pt403Init.descriptionInfo['20']"></div>
                    <br>
                    <table class="personal">
                        <!-- 現在のパスワード -->
                        <tr>
                            <th class="required">
                                <span id="prePassword_lbl">{{$t('pt403.labels.currentPass')}}</span>
                            </th>
                            <td>
                                <input-check v-model="pt403ReqModel.prePassword" id="prePassword" class="passControl" maxlength="16" type="password" autocomplete="off"/>
                            </td>
                        </tr>
                        <!-- 新しいパスワード -->
                        <tr>
                            <th class="required">
                                <span id="password_lbl">{{$t('pt403.labels.newPassword[0]')}}</span>
                            </th>
                            <td>
                                <div v-html="pt403Init.descriptionInfo['5']"></div>
                                <input-check v-model="pt403ReqModel.password" id="password" class="passControl" maxlength="16" type="password" autocomplete="off"/>
                                <div v-html="pt403Init.descriptionInfo['6']"></div>
                            </td>
                        </tr>
                        <!-- 新しいパスワード（確認） -->
                        <tr>
                            <th class="required">
                                <span id="confirmPassword_lbl">{{$t('pt403.labels.newPassword[0]')}} {{$t('pt403.labels.newPassword[1]')}}</span>
                            </th>
                            <td>
                                <div v-html="pt403Init.descriptionInfo['7']"></div>
                                <input-check v-model="pt403ReqModel.confirmPassword" id="confirmPassword" class="passControl" maxlength="16" type="password" autocomplete="off"/>
                                <div v-html="pt403Init.descriptionInfo['8']"></div>
                            </td>
                        </tr>
                    </table>
                    
                    <div id="btn_roll02" class="footerButton">
                        <a class="btnSubmit" @click="isShowAlert = true">{{$t('pt403.buttons.change')}}</a>
                    </div>
                </template>
            </div>
        </div>
        <!-- パスワードを変更します。
        よろしいですか？ -->
        <alert-confirm
            v-if="isShowAlert"
            v-bind:msgConfirm="$t('pt403.messages.alertChangePassword')"
            :okAction="doSubmit"
            size="md"
        />
    </div>
</template>
<script>
/* eslint-disable */
//import $ from 'jquery';
import common from 'assets/js/common';
import axios from "assets/js/request";
import Message from 'components/MessageEcSite';
import InputCheck from 'components/InputCheck';
import SiteConstants from 'assets/const/SiteConstants.json';
import AlertConfirm from 'components/AlertConfirm';
import EventBus from "assets/js/eventBus";
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "3000",
};

export default {
    name: "PT403ChangePassword",
    props:{
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    components: {
        InputCheck,
        Message,
        AlertConfirm,
        Breadcrumb,
        toastr
    },
    data() {
        return {
            PT403_PART: "pt403",
            listIdErr:[],
            listMessValid:[],
            mapMessValid:[],

            pt403ReqModel:{
                prePassword: null,
                password: null,
                confirmPassword: null,
            },
            pt403Init:{
                descriptionInfo:{}
            },
            processType: '0',

            isShowAlert: false,
            SiteConstants: SiteConstants,
            site: ""
        }
    },
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        _this.processType = '0';

        if (_this.ptInitData){
            _this.pt403Init = _this.ptInitData;
            
            // 未ログインの場合
            if (!_this.pt403Init.isLogin) {
                // ログイン画面へ遷移
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
            }
        }else{
            // eslint-disable-next-line
            axios.get(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT403 + _this.$UrlConstants.DO_INIT).then(function(response) {
                _this.pt403Init = response.data;
                
                // 未ログインの場合
                if (!_this.pt403Init.isLogin) {
                    // ログイン画面へ遷移
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 18}});
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });            
        }

        EventBus.$on('closed', () => {
            _this.isShowAlert = false;
        });
    },
    methods: {
        /**
         * update new password
         * @param
         * @returns
         */
        doSubmit: function(){
            var _this = this;
            _this.isShowAlert = false;
            _this.listMessValid = [];
            _this.mapMessValid = [];
            common.clearMessageEcSite(_this.listIdErr, _this.PT403_PART);
            _this.$emit("event-loading", true);

            // Call API send mail update password
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT403 + _this.$UrlConstants.DO_UPDATE, _this.pt403ReqModel).then(function(response) {
                if(response.data.status == 'OK'){
                    // パスワード変更完了メッセージを表示
                    toastr.success(_this.$t('pt403.messages.changedPassword'));
                    // マイメニュー画面へ遷移
                        _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: 81}});
                }
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                // eslint-disable-next-line
                if(error != null && error != undefined){
                    if(error.response != null && error.response != undefined){
                        if (406 == error.response.status) {
                            var resultValid = common.excuteValidationEcSite(error, _this.PT403_PART);
                            if (resultValid) {
                                _this.listIdErr.push.apply(_this.listIdErr, resultValid.listIdErr);
                                _this.listMessValid = resultValid.msgList;
                                _this.mapMessValid = resultValid.mapMsg;
                            }
                        } else {
                            common.errorAPI(error);
                        }
                    }
                }
            });
        },

        /*
        * Goto top page pg010
        */
        pageBack: function(loginFlg) {
            var _this = this;
            _this.$router.push({name: _this.SiteConstants.PG010MAIN, query:{pageNo:1}});
        },
    },

    created() {
    }
}
</script>

